import {VideoOrImageType} from '@local/types'
import {SanityImage, SmallText} from '@local/ui/components'
import CalendarSVG from '@local/assets/svgs/icon-date.svg'
import Link from 'next/link'
import {cx} from '@local/utils/cx'

type TagTypes =
	| 'kaer-choice'
	| 'coming-soon'
	| 'fully-booked'
	| 'last-spots'
	| 'previous-experience';

export interface ExperienceGridCardProps {
	experienceType: string
	title: string
	location: string
	dateRange?: string
	priceStart: number
	media: VideoOrImageType
	keyword?: string
	slug: string;
	slugPrefix: string
	activityType?: string
	region: string
	tag?: TagTypes | string
	onlyMobile?: boolean
	maxPeopleCount?: number
}

const ExperienceGridCard = ({
	experienceType,
	title,
	location,
	dateRange,
	priceStart,
	media,
	slug,
	slugPrefix,
	activityType,
	tag,
}: ExperienceGridCardProps) => {
	return (
		<Link href={`/${slugPrefix}/${slug}`}>
			<div className='overflow-hidden group/card rounded-lg outline-none w-full h-full !relative !block min-h-[438px] lg:min-h-[500px]'>
				{(() => {
					const imageToUse = media?.video?.poster || media?.image
					return imageToUse
						? (
							<SanityImage
								priority
								width={335}
								mobileWidth={294}
								height={438}
								image={imageToUse}
								className={
									cx('rounded-lg w-full h-full max-w-full  object-cover aspect-[335/500]',
										'transition-transform duration-700 ease-[cubic-bezier(.35,0,.19,1)]',
										'scale-110 group-hover/card:scale-100 group-focus-visible/card:scale-100 ')
								} />
						)
						: null
				})()}
				<div className={cx(
					'absolute inset-0 z-0  w-full ',
					'transition-[background-color] duration-700 ease-[cubic-bezier(.35,0,.19,1)] ',

					'group-focus-visible/card:bg-black/10 group-hover/card:bg-black/10  ',
				)}>
					<div className='flex flex-row justify-between items-center p-16 w-full'>
						{activityType &&
							<div className='bg-grey-3 rounded-xs px-8 py-4 flex flex-row gap-8 items-center'>
								{/* <PersonSVG className='w-16 h-16' /> */}
								<span className='text-white text-10 uppercase font-sans tracking-doubleWide leading-none font-medium'>{activityType}</span>
							</div>}
						{tag &&
							<div className='bg-white-off rounded-[3px] px-8 py-4 flex flex-row gap-8 items-center h-24'>
								<span className='text-black text-10 uppercase font-sans tracking-doubleWide leading-none font-medium'>{tag.split('-').join(' ')}</span>
							</div>}

					</div>

				</div>
				<div className={cx('absolute bottom-0 left-0 right-0 bg-gradient-to-b from-transparent to-black/80 p-16 ',
				)}>
					<div className='flex flex-col gap-16 border-b border-white/20 pb-16'>
						<div className='border border-white rounded-xs w-fit px-2'>
							<SmallText className='text-white text-9 font-medium leading-tight'>{experienceType}</SmallText>
						</div>

						<h5 className='font-serif font-medium text-28 text-white'>{title}</h5>
					</div>
					<div className='flex flex-row justify-between items-end gap-16 pt-16 w-full'>

						<div className='flex flex-col gap-4 w-full'>
							<span className='text-white text-14 font-[350] leading-relaxed whitespace-nowrap'>{location}</span>

							<div className='flex flex-row w-full justify-between'>
								<div className={cx('flex flex-row gap-8 items-center', !dateRange && 'opacity-0')}>
									<CalendarSVG className='w-16 h-16' />
									<span className='text-white uppercase text-10 font-sans tracking-doubleWide font-medium leading-tight whitespace-wrap'>
										{dateRange}
									</span>
								</div>
								{!!priceStart &&
									<div className='flex flex-row gap-12 items-center border border-white/50 rounded-2 px-8 py-4 max-w-[130px]'>
										<span className='text-white font-sans text-12 uppercase font-medium leading-tight'>From</span>
										<span className='text-white font-sans text-12 uppercase font-medium leading-tight'>{priceStart}€</span>
									</div>}

							</div>

						</div>

					</div>
				</div>
			</div>
		</Link>
	)
}

export default ExperienceGridCard
